import React from 'react';
import SearchInput from '../../../../../../views/pages/manage/masters/onlinePackage/SearchInput';
import APopover from '../../../../../../views/pages/manage/common/a-popover';
import AButton from '../../../../../../views/pages/manage/common/form-fields-mui/AButton';
import FilterForm from './FilterForm';
import AInput from '../../../../../../views/pages/manage/common/formFeilds/customInput/AInput';
import { Badge } from '@mui/material';

const Filters = ({
  receiptsFilterForm,
  setReceiptsFilterForm
}) => {
  
    return ( 
        <div className='d-flex' style={{gap : '1rem'}}>
            {/* <SearchInput
              inputStyles={{ border : '1px solid #CFD3D4'}}
              placeholder={"Search by Receipt no"}
            //   searchInputValueHandler={searchHandler}
            //   onCancel={cancelSearchHandler}
            /> */}
            <AInput
            value={receiptsFilterForm?.receiptId}
            handler={val => setReceiptsFilterForm(prev => ({...prev, receiptId : val}))}
            placeholder={"Search by Receipt Id"}
            />

            <APopover
              buttonComponent={(openPopover) => (
                <Badge badgeContent={receiptsFilterForm?.fromDate ? 2 : 0} color='primary'>
                <AButton variant="outline" onClick={openPopover} size="xs" className='no-ml-btn'>
                  Filter
                </AButton>
                </Badge>
              )}
              menuComponent={(closePopup) => (
                   <FilterForm 
                   receiptsFilterForm={receiptsFilterForm}
                   setReceiptsFilterForm={setReceiptsFilterForm}
                   closePopup={closePopup}
                   />
              )}
            />
        </div>
     );
}
 
export default Filters;